import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import AppraisalList from '../../components/Appraisal/list'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_submitted_appraisal_forms } from '../../actions/v3/appraisal'
import { replacePageState } from '../../utils';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)

    useEffect(() => {
        v3_submitted_appraisal_forms(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.submittedAppraisals.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit])

    return (
        <Layout
            title={'Appraisal Submitted'}
        >
            {data && <AppraisalList
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List